<template>
  <div>
    <div v-if="!displayDiff2Html" class="col">
      <div class="rounded mb-1" v-for="(valueFirstElement,index) in inputTableSelectorsValues" :key="'valueFirstElement-'+index" :class="{'bg-light': areSelectorsValuesEquals, 'bg-info': !areSelectorsValuesEquals}"> {{ valueFirstElement }} </div>

      <div v-if="!areSelectorsValuesEquals">
        <span class="icon icon-mobile-data-toggle mt-1 mb-1 mr-0 ml-0 compare-icon-sm" aria-hidden="true" :title="'becomes'"></span>
      </div>

      <div class="rounded mb-1" v-for="(valueSecondElement,index) in revisedTableSelectorsValues" :key="'valueSecondElement-'+index" :class="{'bg-danger': !areSelectorsValuesEquals, 'd-none': areSelectorsValuesEquals}"> {{ valueSecondElement }} </div>
    </div>

    <div v-if="displayDiff2Html && areSelectorsValuesEquals" class="col">
      <div class="rounded mb-1 bg-light" v-for="(valueFirstElement,index) in inputTableSelectorsValues" :key="'valueFirstElement-'+index"> {{ valueFirstElement }} </div>
    </div>

    <div v-if="displayDiff2Html && !areSelectorsValuesEquals" class="col">
      <div class="rounded mb-1 diff-div" v-html="diffHtml"></div>
    </div>

  </div>
</template>
<script>
const Diff = require("diff"); 
const Diff2html = require("diff2html");
import 'diff2html/bundles/css/diff2html.min.css'

export default {
  name: "EntryContentDiff",
  components: {
  },
  props: ["displayDiff2Html", "inputTableSelectorsValues", "revisedTableSelectorsValues", "concatSeparator"],
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
    separator: function() {
      return (this.concatSeparator === undefined) ? '\n' : this.concatSeparator;
    },
    areSelectorsValuesEquals: function() {
      return this.areEquals(this.concatArray(this.inputTableSelectorsValues, this.separator), this.concatArray(this.revisedTableSelectorsValues, this.separator));
    },
    diffHtml: function() {
      return this.diff(this.concatArray(this.inputTableSelectorsValues, this.separator), this.concatArray(this.revisedTableSelectorsValues, this.separator))
    }
  },
  methods: {
    concatArray: function(array, separator) {
      const startLine = undefined;
      return array.reduce((previousValue, currentValue) => {
        if (previousValue === startLine) {
          return currentValue;
        } else {
          return `${previousValue}${separator}${currentValue}`; 
        }
      }, startLine);
    },
    diff: function(str1, str2) {
      if (this.displayDiff2Html !== true) {
        return "";
      } else {
        const diffChars = Diff.createTwoFilesPatch("table", "table", str1, str2, "content", "content");
        const diffJson = Diff2html.parse(diffChars);
        const diffHtml = Diff2html.html(diffJson, {
          drawFileList: false,
          fileListToggle: false,
          fileListStartVisible: false,
          matching: 'lines',
          outputFormat: 'line-by-line',
          synchronisedScroll: false,
          highlight: true,
          rawTemplates: {
            'file-summary-line': '',
            'file-summary-wrapper': '',
            'generic-block-header': '',
            //'line-by-line-file-diff': '<table class="d2h-diff-table aa"><tbody class="d2h-diff-tbody">{{diffs}}</tbody></table>',
            'line-by-line-file-diff': '<div class="text-center">{{{diffs}}}</div>',
            'generic-line': '<div class="{{contentClass}} {{type}} flex-wrap pr-0 pl-0 text-wrap rounded mb-1">{{#content}}<span class="diff-content-d2h">{{{content}}}</span>{{/content}}{{^content}}<span class=""><br/></span>{{/content}}</div>',
          },
          renderNothingWhenEmpty: true
        });
        return diffHtml;
      }
    },
    areEquals: function(element1, element2) {
      if ((!Array.isArray(element1)) && (!Array.isArray(element2))) {
        return element1 === element2;
      } else if ((Array.isArray(element1)) && (Array.isArray(element2)) && (element1.length === 1) && (element2.length === 1)) {
        return element1[0] === element2[0];
      } else {
        return false;
      }
    }
  }

};
</script>
<style scoped>

.compare-icon-sm {
  font-size: 1rem;
  height: 1rem;
}

.d2h-ins:not(.d2h-change) > span.diff-content-d2h {
  background-color: #97f295;
}

.d2h-del:not(.d2h-change) > span.diff-content-d2h {
  background-color: #ffb6ba;
}

.d2h-cntx > span:not(.diff-content-d2h){
  display: none;
}

</style>